module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou0-083e41841a95ce1f98fd3caed99bb8d9.jpg";